import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '../ui/Button';
import { cn } from '../../lib/utils';

export function ConfirmationStep() {
  const navigate = useNavigate();

  return (
    <div className="text-center py-12 animate-fadeIn">
      <div className="relative mx-auto flex items-center justify-center h-24 w-24 mb-6">
        <div className="absolute inset-0 rounded-full bg-teal-100 animate-ping opacity-25"></div>
        <div className="relative flex items-center justify-center h-20 w-20 rounded-full bg-teal-100">
          <CheckCircle2 className="h-10 w-10 text-teal-600" />
        </div>
      </div>
      
      <h2 className="text-2xl font-bold text-gray-900 mb-4">
        Félicitations !
      </h2>
      
      <p className="text-lg text-gray-600 mb-2">
        Votre compte a été créé avec succès.
      </p>
      
      <p className="text-gray-500 mb-8 max-w-md mx-auto">
        Vous pouvez maintenant vous connecter et commencer à utiliser notre plateforme pour recruter les meilleurs talents.
      </p>
      
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Button
          size="lg"
          variant="primary"
          onClick={() => navigate('/login')}
          className={cn(
            "transition-all duration-300 transform hover:scale-105",
            "shadow-md hover:shadow-lg"
          )}
        >
          Se connecter
        </Button>
        
        <Button
          size="lg"
          variant="outline"
          onClick={() => navigate('/')}
        >
          Retour à l'accueil
        </Button>
      </div>
    </div>
  );
}